<template>
  <div id="app" style="overflow-x: hidden">
    <router-view name="header" />
    <div class="wrapper">
      <router-view />
    </div>
    <router-view name="footer" />
    <modal
      :show.sync="$store.state.account.modals.subscribe"
      class="modal-default"
      :show-close="false"
      headerClasses="justify-content-center"
      style="padding-top: 100px;"
    >
      <p>{{$t('subscribe_desc')}}</p>
      <fg-input v-model="email" placeholder="Email"></fg-input>
      <template slot="footer">
        <n-button type="danger" @click="closeModal('subscribe')">{{$t('CLOSE')}}</n-button>
        <n-button type="success" @click="subscribe()"
          >{{$t('SUBSCRIBE')}}</n-button
        >
      </template>
    </modal>
    <div
      style="position: fixed; left: 0px; top: 0px; width: 100%; height: 100%; background-color: #00000099; cursor: pointer; z-index: 900;"
      v-if="$store.state.account.modals.wallet"
      @click="closeAllPopup()"
    ></div>
    <div
      v-if="$store.state.account.modals.wallet"
      style="position: fixed; top: calc((100% - 440px) / 2); left: calc((100% - 530px) / 2); padding-top: 32px; text-align: center; width: 530px; height: 340px; background-image: url('/img/1st_sale/pop_wallet.png'); z-index: 10000;"
    >
      <div
        style="position: absolute; top: 28px; right: 30px; width: 40px; height: 40px; cursor: pointer;"
        @click="closeModal('wallet')"
      >
        <img src="/img/event/btn_close.png" />
      </div>
      <h5 style="color: white; font-size: 24px; font-weight: 900;">{{$t('connect_wallet')}}</h5>
      <div style="position: absolute; top: 120px; left: 39px; width: 458px; height: 107px;">
        <img
          src="/img/1st_sale/icon_wallet_1.png"
          style="margin-right: 10px; cursor: pointer;"
          @click="connect('metamask')"
        />
        <!-- <img
          src="/img/1st_sale/icon_wallet_2.png"
          style="margin-right: 10px; cursor: pointer;"
          @click="connect('dappcom')"
        /> -->
        <img
          src="/img/1st_sale/icon_wallet_3.png"
          style="margin-right: 10px; cursor: pointer;"
          @click="connect('torus')"
        />
        <!-- <img
          src="/img/1st_sale/icon_wallet_4.png"
          style="cursor: pointer;"
          @click="connect('trust')"
        /> -->
      </div>
      <h6
        style="position: absolute; bottom: 40px; color: black; font-size: 18px; font-weight: 500; width: 100%; text-align: center;"
      >{{$t('info_select_wallet')}}</h6>
    </div>
  </div>
</template>

<script>
import { Modal, Button, FormGroupInput } from '@/components';
import config from "./config.js";
import axios from 'axios';
import {connectWallet} from "./utils/wallet";

export default {
  components: {
    Modal,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
  },
  data() {
    return {
      email: ''
    };
  },
  methods: {
    connect: async function(type) {
      var balance = 0;
      let account = connectWallet(this.$store, type);
      this.closeModal("wallet");
    },
    closeAllPopup() {
      this.closeModal("wallet");
    },
    closeModal: function(modalName) {
      this.$store.commit(`closeModal`, modalName);
    },
    subscribe: async function() {
      let email = this.email.trim();
      if (email.length < 3) {
        alert(this.$t(`alert_invalid_email`));
        return;
      }
      let device = '';
      if (this.$device.mobile) {
        device = 'mobile/';
        if (this.$device.android || this.$device.androidPhone) {
          device += 'android';
        }
        else {
          device += 'ios';
        }
      }
      else {
        device = 'pc';
      }
      let parameters = JSON.parse(localStorage.parameters);
      let ret = await axios.post(`${config.api.stat_url}/preregist/subscribe`, {email: email, utm_source: parameters.utm_source, utm_medium: parameters.utm_medium, ref: parameters.ref, device: device, language: navigator.language, language2: this.$i18n.locale, from: 'land'});
      if (ret.data.result == false) {
        alert(this.$t(`alert_${ret.data.err.code}`));
      }
      else {
        alert(this.$t(`subscribe_ok`));
      }
      this.closeModal('subscribe');
    }
  }
}
</script>